"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CommonBankAccountValidator_1 = __importDefault(require("../CommonBankAccountValidator"));
var BanrisulCheckNumberCalculator_1 = __importDefault(require("./CheckNumber/BanrisulCheckNumberCalculator"));
var BanrisulValidator = /** @class */ (function (_super) {
    __extends(BanrisulValidator, _super);
    function BanrisulValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BanrisulValidator.prototype.agencyCheckNumberIsValid = function (agencyCheckNumber) {
        return agencyCheckNumber === undefined || agencyCheckNumber === "";
    };
    BanrisulValidator.prototype.accountNumberIsValid = function (accountNumber) {
        return accountNumber.length === this.accountNumberLength() && _super.prototype.accountNumberIsValid.call(this, accountNumber);
    };
    BanrisulValidator.prototype.accountCheckNumberMatch = function (bankAccount) {
        var checkNumberCalculated = BanrisulCheckNumberCalculator_1.default.calculate(bankAccount.accountNumber);
        return checkNumberCalculated === bankAccount.accountCheckNumber;
    };
    BanrisulValidator.prototype.accountNumberLength = function () {
        return 9;
    };
    return BanrisulValidator;
}(CommonBankAccountValidator_1.default));
exports.default = BanrisulValidator;
//# sourceMappingURL=BanrisulValidator.js.map